export const AUTHORIZE_PENDING_USER = 'AUTHORIZE_PENDING_USER';
export const DELETE_PENDING_UNAUTHORIZED_USER = 'DELETE_PENDING_UNAUTHORIZED_USER';
